import styled from 'styled-components';
import { CarouselWrapper } from '../../CustomCarousel/style';
import { getUrlWithToken } from '../../../../utils/common';

export const CategorySection = styled.div`
  padding: 0 48px;
  max-width: 1440px;
  margin: auto;
  @media ${(props) => props.theme.device.tablet} {
    padding: 0;
  }
  .text-container {
    @media ${(props) => props.theme.device.tablet} {
      padding: 0 16px;
    }
  }
`;

export const CategoryCard = styled.div`
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 4px 20px rgba(104, 104, 104, 0.1);
  border-radius: 4px;
  max-height: 483px;
  height: 100%;

  .card-body {
    padding: 28px 24px 33px;
  }

  .body {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const CategoryCarouselWrapper = styled(CarouselWrapper)`
  .slick-slide {
    @media ${(props) => props.theme.device.tablet} {
      margin: 0 8px;
    }
  }

  .slick-dots {
    max-width: calc(100vw - 150px);
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;

    scrollbar-width: none; //hides the scrollbar without disabling scroll
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Cover = styled.div`
  height: 305px;
  background: url(${({ src }) => getUrlWithToken(src)});
  background-position: center center;
  background-size: cover;
`;

export const Overlay = styled.div`
  width: 100%;
  height: inherit;
  background: linear-gradient(
    0deg,
    #050505 -13.37%,
    rgba(255, 255, 255, 0) 104.73%
  );
  border-radius: 4px 4px 0px 0px;
`;
